<!-- MyPlan.vue -->
<template>
  <div class="my-plan-container">
    <div class="title-1">{{ planData.title }}</div>
    <div class="plan-grid">
      <!-- 情况一：3条数据 -->
      <div v-if="chartData.length === 3" class="left-column">
        <div
          class="plan-item flex-between"
          v-for="(item, index) in chartData.slice(0, 2)"
          :key="index"
          @click.stop="goDetail(item)"
        >
          <div class="plan-content">
            <div class="plan-name">{{ item.name }}</div>
            <div class="plan-count">{{ item.value }}</div>
          </div>
          <div class="right-icon flex-center">
            <a-icon type="right" style="font-size: 14px; color: #fff" />
          </div>
        </div>
      </div>

      <div v-if="chartData.length === 3" class="right-column">
        <div class="plan-item" @click.stop="goDetail(chartData[2])">
          <div class="flex-between" style="transform: translateY(20px)">
            <div class="plan-content">
              <div class="plan-name">{{ chartData[2].name }}</div>
              <div class="plan-count">{{ chartData[2].value }}</div>
            </div>
            <div class="right-icon flex-center">
              <a-icon type="right" style="font-size: 14px; color: #fff" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MyPlan',
  props: {
    planData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    chartData() {
      return this.planData.chartData || []
    },
  },
  methods: {
    goDetail(item) {
      this.$router.push({
        path: item.path,
        query: item.query,
      })
    },
  },
}
</script>

<style scoped lang="less">
.my-plan-container {
  box-sizing: border-box;
  height: 350px;
  padding: 15px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.title-1 {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-bottom: 12px;
}

.plan-grid {
  display: flex;
  gap: 30px;
  margin-top: 15px;
  height: 280px;
}

.left-column {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 15px;
}

.right-column {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 15px;
  .plan-item {
    align-items: normal !important;
  }
}

.plan-item {
  flex: 1;
  box-sizing: border-box;
  padding: 20px;
  border-radius: 10px;
  cursor: pointer;
  background-color: #f8fafc;
  transition: all 0.2s ease;

  &:hover {
    background-color: #eef2f7;
  }

  &.active {
    background-color: #eef2f7;
  }
}

.plan-name {
  font-size: 14px;
  color: #666;
  margin-bottom: 4px;
  text-align: center;
}

.plan-count {
  font-size: 24px;
  font-weight: bold;
  color: #333;
}

.right-icon {
  width: 16px;
  height: 16px;
  background-color: #d7d9d9;
  border-radius: 50%;
}
</style>
